import React, { useState } from "react";
import InputField from "./forms/input/TextInput/InputField";
import FormButton from "./ui/button/FormButton";
import { Stack, Grid, TextField, MenuItem, InputLabel } from "@mui/material";
import data from "./dropDown";
import Spinner from "./ui/Spinner";
import { apiRequest, baseURL } from "../services/auth";
import { toast } from "react-toastify";

const IndividualPayerId = () => {
  const { Lga } = data;
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    house_number: "",
    street: "",
    town: "",
    email: "",
    phone_number: "",
    lga: "",
  });

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value.trim(),
    }));
  };
  // const url = `${baseURL}/cbs/individual_payer`;
  const IndPayerId = async () => {
    setLoading(true); // Start loading state
    // Validation
    const errors = [];
    if (!formData.first_name || !/^[a-zA-Z]{3,}$/.test(formData.first_name)) {
      errors.push(
        "First name should contain only alphabetic characters and be at least 3 characters long."
      );
    }
    if (!formData.last_name || !/^[a-zA-Z]{3,}$/.test(formData.last_name)) {
      errors.push(
        "Last name should contain only alphabetic characters and be at least 3 characters long."
      );
    }
    if (!formData.house_number || !/^\d+$/.test(formData.house_number)) {
      errors.push("House number should contain only numbers.");
    }

    if (
      !formData.phone_number ||
      formData.phone_number.length !== 11 ||
      !/^\d+$/.test(formData.phone_number)
    ) {
      errors.push("Phone number should contain exactly 11 digits.");
    }

    if (errors.length > 0) {
      // Display validation errors
      errors.forEach((error) => {
        toast.error(error, {
          autoClose: false,
          hideProgressBar: false,
          draggable: false,
          closeOnClick: false,
        });
      });
      setLoading(false); // End loading state
      return;
    }
    const url = `${baseURL}/cbs/individual_payer`;
    console.log(url);
    // delete formData.phon_number;
    console.log(formData);

    try {
      // const response = await axios.post(url, formData)
      const response = await fetch(url, {
        method: "post",
        body: JSON.stringify(formData),
        headers: {
          "Content-Type": "application/json",
        },
      });
      const resp = await response.json();
      console.log("RESPONSE", resp);
      if (resp?.status === "success") {
        toast.success(`Your PayerId is ${resp?.data?.payer_id}`, {
          autoClose: false,
          hideProgressBar: false,
          draggable: false,
          closeOnClick: false,
        });
      } else {
        toast.error(resp?.message);
      }
    } catch (error) {
      console.log("Error:", error);
      toast.error(error.message);
    } finally {
      setLoading(false); // End loading state
    }
  };

  return (
    <div style={{ maxHeight: "calc(100vh - 10px)", overflowY: "auto" }}>
      {/* 1st column */}
      <h2>Individual Payer ID</h2>
      <div
        style={{
          display: "flex",
          flexWrap: window.innerWidth <= 462 ? "wrap" : "nowrap",
          alignItems: "center",
          gap: "1.5rem",
          padding: "1rem",
        }}
      >
        <InputField
          name="first_name"
          label="First Name"
          placeholder=" Enter First Name"
          type="text"
          value={formData.firstName}
          onChange={handleFormChange}
          style={{ width: "15rem" }}
        />

        <InputField
          name="last_name"
          label="Last Name"
          type="text"
          placeholder="Enter Last Name"
          value={formData.lastName}
          onChange={handleFormChange}
          style={{ width: "15rem" }}
        />

        <InputField
          name="house_number"
          label="House Number"
          placeholder="Enter House Number"
          type="text"
          value={formData.houseNumber}
          onChange={handleFormChange}
          style={{ width: "15rem" }}
        />
      </div>
      {/* 2nd column */}
      <div
        style={{
          display: "flex",
          flexWrap: window.innerWidth <= 462 ? "wrap" : "nowrap",
          alignItems: "center",
          gap: "1.5rem",
          padding: "1rem",
          overflowY: "auto", // Add scroll when content overflows
          maxHeight: "calc(100vh - 10px)", // Limit height to viewport height
        }}
      >
        <InputField
          name="street"
          label="Street Name"
          placeholder=" Enter Street Name"
          type="text"
          value={formData.street}
          onChange={handleFormChange}
          style={{ width: "15rem" }}
        />

        <InputField
          name="town"
          label="Town"
          type="text"
          placeholder="Town"
          value={formData.town}
          onChange={handleFormChange}
          style={{ width: "15rem" }}
        />

        <InputField
          name="email"
          label="Email"
          placeholder=" Enter Email"
          type="text"
          value={formData.contactEmail}
          onChange={handleFormChange}
          style={{ width: "15rem" }}
        />
      </div>
      {/* 3rd column */}
      <div
        style={{
          display: "flex",
          flexWrap: window.innerWidth <= 462 ? "wrap" : "nowrap",
          alignItems: "center",
          gap: "1.5rem",
          padding: "1rem",
        }}
      >
        <InputField
          name="phone_number"
          label="Phone Number"
          placeholder=" Enter Phone Number"
          type="text"
          value={formData.phone_number}
          onChange={handleFormChange}
          style={{ width: "15rem" }}
        />

        <TextField
          label="Select LGA"
          select
          value={formData.lga}
          onChange={(e) =>
            setFormData((prevState) => ({
              ...prevState,
              lga: e.target.value,
            }))
          }
          style={{
            height: "100%",
            width: "15rem",
            marginTop: "2rem",
          }}
        >
          {Lga.map((lgaItem) => (
            <MenuItem key={lgaItem.ledId} value={lgaItem.name}>
              {lgaItem.name}
            </MenuItem>
          ))}
        </TextField>

        <Stack style={{ marginTop: "1.5rem" }}>
          {/* Register Button */}
          <FormButton
            type="submit"
            label={loading ? <Spinner width="5%" /> : "Get Payer Id"}
            width="medium"
            onClick={IndPayerId}
          />
        </Stack>
      </div>
      {/* 3rd column */}
    </div>
  );
};

export default IndividualPayerId;
